import createEnum from 'scripts/lib/create_enum';

/**
 * InteractionType is the shared content types used across Liveboards, Reports, and Search
 * The goal is for InteractionType to eventually replace service specific ContentTypes and instead rely on this single InteractionType
 */
export default createEnum(
  'ABANDONED_CALL',
  'CHAT',
  'EMAIL',
  'FB_MESSENGER',
  'INSTAGRAM_DIRECT',
  'PHONE_CALL',
  'SMS',
  'TASK',
  'TWITTER',
  'VOICEMAIL',
  'WHATSAPP'
);



// WEBPACK FOOTER //
// ./src/scripts/domain/models/interaction_type.js